<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      
                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-12">
                                                <div class="row">

                                                    <div class="col-xl-4 col-xs-12 col-md-6 col-lg-4">
                                                        <div class="submit-field">
                                                            <h5>Local do estoque</h5>
                                                            <select class="with-border margin-bottom-5" readonly style="pointer-events: none;">
                                                                <option value="" v-if="estoque.ativo">{{estoque.ativo.nome}}</option>
                                                            </select>
                                                            <small v-if="estoque.ativo" class="margin-bottom-0"><b>- Qntd. atual:</b> {{parseFloat(estoque.ativo.quantidade).toLocaleString()}}L</small>
                                                            <small v-if="estoque.ativo" class="margin-bottom-0"><b>- Capacidade:</b> {{parseFloat(estoque.ativo.capacidade).toLocaleString()}}L</small>
                                                            <small v-if="estoque.ativo" class="margin-bottom-10"><b>- Numeração atual:</b> {{parseFloat(estoque.ativo.numero).toLocaleString()}}</small>
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-4 col-xs-12 col-md-6 col-lg-4">
                                                        <div class="submit-field">
                                                            <h5>Tipo da movimentação</h5>
                                                            <select class="with-border" v-model="form.tipo" v-if="estoque.ativo">
                                                                <option value="" disabled selected hidden>Selecione..</option>
                                                                <option value="transferencia">Transferência entre tanques</option>
                                                                <option value="transferencia-filial">Transferência para outra filial</option>
                                                                <option value="entrada">Entrada</option>
                                                                <option value="saida">Saída</option>
                                                                <option value="medicao" v-if="estoque.ativo.tipo == 'tanque'">Medição do tanque</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    
                                                    <div class="col-xl-4 col-xs-12 col-lg-4 col-md-6" v-if="estoque.ativo && form.tipo == 'transferencia'">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Local do estoque de destino</h5>
                                                            <select class="with-border margin-bottom-5" v-model="form.destinoEstoqueCod">
                                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                                <option v-for="item in estoque.itens" v-if="item.empresaCod == estoque.ativo.empresaCod && item.catalogoCod == estoque.ativo.catalogoCod && item.cod != estoque.ativo.cod" :value="item.cod">{{item.nome}}</option>
                                                            </select>                                                   
                                                            <small v-if="estoque.destino" class="margin-bottom-0"><b>- Qntd. atual:</b> {{parseFloat(estoque.destino.quantidade).toLocaleString()}}L</small>
                                                            <small v-if="estoque.destino" class="margin-bottom-0"><b>- Capacidade:</b> {{parseFloat(estoque.destino.capacidade).toLocaleString()}}L</small>
                                                            <small v-if="estoque.destino"><b>- Numeração atual:</b> {{parseFloat(estoque.destino.numero).toLocaleString()}}</small>
                                                        </div>
                                                        <div style="display: block; height: 10px;"></div>
                                                    </div>   

                                                    <div class="col-xl-4 col-xs-12 col-lg-4 col-md-6" v-if="estoque.ativo && form.tipo == 'transferencia-filial'">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Local do estoque de destino</h5>
                                                            <select class="with-border margin-bottom-5" v-model="form.destinoEstoqueCod">
                                                                <option value="" disabled selected hidden>Selecione aqui..</option>
                                                                <option v-for="item in estoque.itens" v-if="item.catalogoCod == estoque.ativo.catalogoCod && item.cod != estoque.ativo.cod" :value="item.cod">{{item.empresaNome + ' - ' + item.nome}}</option>
                                                            </select>                                                   
                                                            <small v-if="estoque.destino" class="margin-bottom-0"><b>- Qntd. atual:</b> {{parseFloat(estoque.destino.quantidade).toLocaleString()}}L</small>
                                                            <small v-if="estoque.destino" class="margin-bottom-0"><b>- Capacidade:</b> {{parseFloat(estoque.destino.capacidade).toLocaleString()}}L</small>
                                                            <small v-if="estoque.destino"><b>- Numeração atual:</b> {{parseFloat(estoque.destino.numero).toLocaleString()}}</small>
                                                        </div>
                                                        <div style="display: block; height: 10px;"></div>
                                                    </div>                                                                                                          

                                                    <div class="col-xl-5 col-lg-5 col-md-7" v-bind:class="{'disabled': !form.tipo}">
                                                        <div class="submit-field">
                                                            <h5>Observações</h5>
                                                            <input type="text" class="with-border" placeholder="Escreva aqui.." v-model="form.observacao">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-3 col-lg-4 col-md-4 col-xs-6" v-bind:class="{'disabled': !form.tipo}" v-if="form.tipo != 'medicao'">
                                                        <div class="submit-field">
                                                            <h5>Quantidade <br class="hidden-lg hidden-md hidden-xl">(litros)</h5>
                                                            <input type="number" class="with-border margin-bottom-5" placeholder="_____" v-model="form.quantidade" />
                                                            <!-- <the-mask :mask="['###', '#', '##', '####', '#####', '######', '#######']"  type="tel" class="with-border margin-bottom-5" placeholder="_____" v-model="form.quantidade" /> -->
                                                            <small v-if="estoque.final" class="margin-bottom-0"><b>- Qntd. final:</b> {{parseFloat(estoque.final.quantidade).toLocaleString()}}L</small>
                                                            <div style="display: block; height: 10px;"></div>
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-3 col-lg-4 col-md-4 col-xs-6" v-if="form.tipo == 'transferencia' || form.tipo == 'saida' || form.tipo == 'transferencia-filial'">
                                                        <div class="submit-field">
                                                            <h5>Numeração da <br class="hidden-lg hidden-md hidden-xl">bomba</h5>
                                                            <!-- <the-mask :mask="['###', '#', '##', '####', '#####', '######', '#######', '########', '#########', '##########']"  type="tel" class="with-border margin-bottom-5" placeholder="_____" v-model="form.numero" /> -->
                                                            <input type="number" class="with-border margin-bottom-5" placeholder="_____" v-model="form.numero" />
                                                            <small v-if="estoque.final" class="margin-bottom-0"><b>- Numeração final de:</b> {{estoque.ativo.nome}}</small>
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-3 col-lg-4 col-md-4 col-xs-6" v-if="form.tipo && estoque.ativo.tipo == 'tanque' && form.tipo != 'entrada' && form.tipo != 'saida' && form.tipo != 'transferencia' && form.tipo != 'transferencia-filial'">
                                                        <div class="submit-field">
                                                            <h5>Medição do <br class="hidden-lg hidden-md hidden-xl">tanque (cm)</h5>
                                                            <the-mask :mask="['###', '#', '##', '####', '#####', '######', '#######', '########', '#########', '##########']"  type="tel" class="with-border margin-bottom-5" placeholder="_____" v-model="form.medicao" />
                                                            <small class="margin-bottom-0" v-if="form.tipo != 'medicao' && form.tipo != 'entrada'">Opcional</small>
                                                            <small class="margin-bottom-0" v-if="form.tipo != 'medicao' && form.tipo == 'entrada'">Informe a medição do tanque <b>após</b> a entrada de combustível.</small>
                                                        </div>
                                                    </div>     


                                                    <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12" v-if="form.tipo && estoque.ativo.tipo == 'tanque' && form.tipo != 'entrada' && form.tipo != 'saida' && form.tipo != 'transferencia' && form.tipo != 'transferencia-filial' && form.primeiraMedicao">
                                                        <div class="submit-field">
                                                            <h5>Foto da registradora após medição</h5>                                                            
                                                            <div class="uploadButton">
                                                                <input class="uploadButton-input" type="file" name="arquivo" @change="getBase64Imagem" accept="*" :id="'upload-arquivo-medicao'" />
                                                                <label class="uploadButton-button" :for="'upload-arquivo-medicao'">
                                                                    <i v-if="form.arquivo" class="material-icons" style="margin-right: 3px;">check_circle</i>
                                                                    <i v-if="!form.arquivo" class="material-icons" style="margin-right: 3px;">attach_file</i>
                                                                    <b v-show="!form.arquivo">Enviar foto</b>
                                                                    <b v-show="form.arquivo">Alterar foto</b>
                                                                </label>
                                                                <span class="uploadButton-file-name"></span>
                                                            </div>
                                                            <img :src="form.arquivo" style="width: 200px; border: 1px solid #ddd; margin-top: 1px;" v-if="form.arquivo">                     
                                                        </div>
                                                    </div>                                                         

                                                    <div class="col-xl-12 margin-bottom-20" v-bind:class="{'disabled': !form.tipo}">
                                                        <div class="hidden-xl" style="display: block; height: 15px;"></div>
                                                        <button type="submit" class="button big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                            <i class="material-icons">save</i>
                                                            Cadastrar movimentação
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'MovimentarEstoque',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {    
            "estoqueMedicao": {
                "itens":            []
            },                  
            "loading": {
                "submit":           false
            },
            "estoque": {
                "ativo":            null,
                "destino":          null,
                "final":            null,
                "itens":            []
            },            
            "form": {
                "acao":             "movimentar",
                "tipo":             "",
                "destinoEstoqueCod":"",
                "observacao":       "",
                "catalogoCod":      "",
                "quantidade":       "",
                "medicao":          "",
                "numero":           ""
            }            
        }
    },
    watch: {
        "form.tipo": function(val) {
            console.log("change >> form.tipo()", val);
            var self        = this;

            self.atualizarEstoque();
        },
        "form.quantidade": function(val) {
            console.log("change >> form.quantidade()", val);
            var self        = this;

            self.atualizarEstoque();
        },
        "form.destinoEstoqueCod": function(val) {
            console.log("change >> form.destinoEstoqueCod()", val);

            var self        = this;
            var destino     = null;
            self.estoque.itens.forEach(function(item) {
                if (item.cod == val) destino = item;
            });
            console.log("Destino:", destino);
            if (destino) {
                self.estoque.destino = destino;
                self.$forceUpdate();
            }

            self.atualizarEstoque();
        }
    },
    methods: {
        getBase64Imagem: function(event) {
            var self            = this;

            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        loading.hide();
                        self.form.arquivo    = result;
                        self.$forceUpdate();
                    });
                }); 
            }   
        },          
        escolherImagem: function() {
            var self = this;
            if (!window.cordova) {
                $(".uploadButton-button").click();        
            } else if (window.cordova.platformId == "ios") {
                $(".uploadButton-button").click();        
            } else {
                navigator.notification.confirm(
                    '', 
                    function(buttonIndex) {
                        if (buttonIndex == 1) {
                            navigator.camera.getPicture(function(imageData) {
                                self.form.imagem = "data:image/jpeg;base64," + imageData;
                            }, function(message){
                            }, {
                                quality: 35,
                                saveToPhotoAlbum: true,
                                destinationType: Camera.DestinationType.DATA_URL,
                                targetWidth: 1000,
                                correctOrientation: true,
                                targetHeight: 0
                            });                        
                        }
                        if (buttonIndex == 2) {
                            $(".uploadButton-button").click();
                        }                    
                    },          
                    'Escolher foto',   
                    ['Câmera','Galeria'] 
                );            
            }

        },        
        atualizarEstoque: function() {
            console.log("atualizarEstoque()");
            var self                = this;
            if (self.form.tipo == "transferencia-filial" || self.form.tipo == "transferencia" || self.form.tipo == "saida") {
                self.form.numero    = parseFloat(self.form.quantidade) + parseFloat(self.estoque.ativo.numero);
            } else {
                self.form.numero    = parseFloat(self.estoque.ativo.numero);
            }            

            if (self.form.tipo == "saida") {
            
                self.estoque.destino            = null;
                self.form.destinoEstoqueCod     = "";
                self.estoque.final              = JSON.parse(JSON.stringify(self.estoque.ativo));
                self.estoque.final.quantidade   = parseFloat(self.estoque.ativo.quantidade) - parseFloat(self.form.quantidade || 0);
           
            } else if ((self.form.tipo == "transferencia" || self.form.tipo == "transferencia-filial") && self.form.destinoEstoqueCod) {
           
                self.estoque.final              = JSON.parse(JSON.stringify(self.estoque.destino));
                self.estoque.final.quantidade   = parseFloat(self.estoque.destino.quantidade) + parseFloat(self.form.quantidade || 0);
           
            } else if (self.form.tipo == "entrada") {
           
                self.estoque.destino            = null;
                self.estoque.final              = JSON.parse(JSON.stringify(self.estoque.ativo));
                self.form.destinoEstoqueCod     = "";
                self.estoque.final.quantidade   = parseFloat(self.estoque.ativo.quantidade) + parseFloat(self.form.quantidade || 0);
            
            } else if (self.form.tipo == "medicao") {

                self.estoque.destino            = null;
                self.estoque.final              = JSON.parse(JSON.stringify(self.estoque.ativo));
                self.form.destinoEstoqueCod     = "";
                self.estoque.final.quantidade   = 0;                
                
                loading.show();
                self.getEstoqueMedicao().then(function(result) {

                    var medicao = (self.estoqueMedicao.itens.filter(function(item) {
                        if (item.estoqueCod == self.form.estoqueCod) return item;
                    })[0] || null);
                    console.log("Possui medicao?", medicao);

                    loading.hide();
                    self.form.primeiraMedicao = (medicao ? false : true);
                    self.$forceUpdate();

                }).catch(function(error) {
                    loading.hide();
                    console.log("Erro ao buscar medicao", error);
                    reject(error);
                });

            }

            console.log("Atualizou estoque:", self.estoque);
            console.log("Atualizou form:", self.form);
        },
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", JSON.stringify(self.form));
            e.preventDefault();
                
            if ((self.form.tipo == "transferencia" || self.form.tipo == "transferencia-filial") && !self.form.destinoEstoqueCod) {
                alert("Informe o campo local do estoque de destino.");
                return false;                
            }

            if (self.estoque.final.quantidade < 0) {
                alert("Erro! A quantidade final ficou menor que 0, verifique por favor.");
                return false;
            }

            if (self.form.tipo == "entrada" && self.estoque.final.quantidade > self.estoque.final.capacidade) {
                alert("Erro! A quantidade final ficou maior que a capacidade, verifique por favor.");
                return false;                
            }

            if ((self.form.tipo == "transferencia" || self.form.tipo == "transferencia-filial")) {
                if (self.estoque.final.quantidade > self.estoque.final.capacidade) {
                    alert("Erro! A quantidade final ficou maior que a capacidade, verifique por favor.");
                    return false;                                    
                }
            }

            self.loading.submit = true;
            loading.show();
                
            axios.post("api/estoque-v2.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getEstoqueMedicao: function() {
            var self        = this;
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "estoque",                    
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "medicao",
                        // "empresaCod":   self.form.empresaCod
                    }
                };

                axios.get("api/estoque-v2.php", form)
                .then(response => {
                    
                    self.estoqueMedicao     = response.data.result;
                    self.$forceUpdate();
                    resolve(response.data.result);
                    
                    // if (self.$route.name == "EditarPedidos") {
                    //     setTimeout(function() {
                    //         self.atualizarEstoque();
                    //     }, 100);
                    // }

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));                
                });   
            });   
        },      
        getEstoque: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "group":        false
                    }
                };

                axios.get("api/estoque-v2.php", form)
                .then(response => {
                    
                    console.log("getEstoque() result", response.data);
                    self.estoque.itens  = response.data.result.itens;
                    resolve(response.data.result);

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },                      
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/estoque-v2.php", form)
                .then(response => {
                    
                    console.log("get() response", response.data.result);
                    self.estoque.ativo      = response.data.result;
                    self.form.numero        = response.data.result.numero;
                    self.form.catalogoCod   = response.data.result.catalogoCod;
                    self.form.estoqueCod    = response.data.result.cod;
                    self.loaded             = true;
                    self.$forceUpdate();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$root.user.tipo == "prestador") {
            self.form.empresaCod = self.$root.user.empresaCod;
        }

        self.$root.tmp.estoque.tab = "historico";

        if (self.$route.query.c) {
            self.form.cod = self.$route.query.c;
        }

        Promise.all([
            self.get(),
            self.getEstoque()
        ]).then(function() {
        
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        }); 
    },
    mounted: function() {


    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .dashboard-box .content small {
        display: block;
        line-height: 16px;
        color: #888;
    }
</style>



// WEBPACK FOOTER //
// src/components/MovimentarEstoque.vue